import React from 'react';

export interface LinkTracking {
  linkType?:
    | 'LinkExternalLink'
    | 'LinkInternalLink'
    | 'LinkThematischerLink'
    | 'LinkActionLink'
    | 'LinkAssetLink'
    | 'LinkAnchorLink'
    | 'LinkMenuLink';
  linkText?: string;
  linkHref?: string;
}

const TrackingContext = React.createContext<{
  trackLink?: (payload: LinkTracking) => void;
}>({
  trackLink: undefined,
});

export { TrackingContext };
